<div class="row m-0">
    <div class="col-6 ps-0">
        <dp-filter-card [filterCard]="leftFilterCard" [noResultsVisible]="leftChartValues.length === 0"
            [showLoading]="showLoadingLeftChart" (filterChanged)="loadLeftChartValues($event)">
            @if (leftLineChart) {
                <dp-chart ngProjectAs="body" [chart]="leftLineChart"></dp-chart>
            }
        </dp-filter-card>
    </div>
    <div class="col-6 pe-0">
        <dp-filter-card [filterCard]="rightFilterCard" [noResultsVisible]="rightChartValues.length === 0"
            [showLoading]="showLoadingRightChart" (filterChanged)="loadRightChartValues($event)">
            @if (rightLineChart) {
                <dp-chart ngProjectAs="body" [chart]="rightLineChart"></dp-chart>
            }
        </dp-filter-card>
    </div>
</div>
